import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ClubPredictorPage from './ClubPredictorPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DemoPage() {
  const { demoId } = useParams();
  const [demoClub, setDemoClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/demo/${demoId}`)
      .then(r => { setDemoClub(r.data); setLoading(false); })
      .catch(() => { setError('Demo not found or expired'); setLoading(false); });
  }, [demoId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#1D3557', borderTopColor: 'transparent' }} />
      </div>
    );
  }

  if (error || !demoClub) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[#1D3557] mb-3">Demo Not Found</h1>
          <p className="text-[#1D3557]/50 mb-6">This demo may have expired. Demos are available for 7 days.</p>
          <a href="/demo/create" className="bg-[#E63946] text-white font-bold uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#d32f3c] transition-colors">
            Create a New Demo
          </a>
        </div>
      </div>
    );
  }

  return <ClubPredictorPage demoMode={true} demoClub={demoClub} demoId={demoId} />;
}
